import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { SessionService } from './session.service';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DeducoesService {
  private urlServer = environment.URL_API;

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) {}

  atualizar(matricula: string, idOrgao: string): Observable<any> {
    return this.http.put(`${this.urlServer}/deducao/`, {matriculaOrgao:{matricula,idOrgao}});
  }

  getDeducoes(matricula: string, orgaoId: string): Observable<any> {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.http.get(
      this.urlServer + '/deducao/matricula/' + matricula + '/orgao/' + orgaoId,
      { headers }
    );
  }

  uploadDeducaoDocumento(idOrigem: number, file: File, tipoDocumento = 'LICENCA') {
    const token = this.sessionService.token;
    const matricula = this.sessionService.beneficiario.matricula;
    const idOrgao = this.sessionService.beneficiario.orgao.id;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      // NÃO setar Content-Type manualmente com FormData
    });

    const params = new HttpParams()
      .set('matricula', String(matricula))
      .set('idOrgao', String(idOrgao))
      .set('idOrigem', String(idOrigem))
      .set('tipoDocumento', tipoDocumento);

    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(`${this.urlServer}/files/upload`, formData, {
      headers,
      params,
    });
  }

  /** Download por hash: GET /files/download?hash=...  (retorna Blob) */
  downloadDocumentoPorHash(hash: string): Observable<HttpResponse<Blob>> {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: '*/*',
    });

    const params = new HttpParams().set('hash', hash);

    return this.http.get(`${this.urlServer}/files/download`, {
      headers,
      params,
      responseType: 'blob',
      observe: 'response',
    });
  }

  /** Delete por hash: DELETE /files?hash=... */
  deleteDocumentoPorHash(hash: string) {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const params = new HttpParams().set('hash', hash);

    return this.http.delete(`${this.urlServer}/files`, { headers, params });
  }

  /**
   * Prepara o cadastro de repasse previdenciário para dedução
   * GET /deducao/preparar-cadastro-repasse-deducao/{idDeducao}
   */
  prepararCadastroRepasseDeducao(idDeducao: number): Observable<any> {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.http.get(
      `${this.urlServer}/deducao/preparar-cadastro-repasse-deducao/${idDeducao}`,
      { headers, params: {matricula:this.sessionService.beneficiario.matricula,idOrgao:this.sessionService.beneficiario.orgao.id} }
    );
  }

  /**
   * Salva repasse previdenciário para dedução
   * POST /deducao/save-repasse
   */
  salvarRepasseDeducao(payload: any): Observable<any> {
    const token = this.sessionService.token;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    });

    return this.http.post(
      `${this.urlServer}/deducao/save-repasse`,
      payload,
      { headers }
    );
  }

  /**
   * Upload de documento de repasse previdenciário para dedução
   * POST /files/upload?matricula=&idOrgao=&idOrigem=&tipoDocumento=DOCUMENTO_REPASSE_PREVIDENCIARIO
   */
  uploadDocumentoRepasse(idOrigem: number, file: File): Observable<any> {
    const token = this.sessionService.token;
    const matricula = this.sessionService.beneficiario.matricula;
    const idOrgao = this.sessionService.beneficiario.orgao.id;

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const params = new HttpParams()
      .set('matricula', String(matricula))
      .set('idOrgao', String(idOrgao))
      .set('idOrigem', String(idOrigem))
      .set('tipoDocumento', 'DOCUMENTO_REPASSE_PREVIDENCIARIO');

    const formData = new FormData();
    formData.append('file', file);

    return this.http.post(`${this.urlServer}/files/upload`, formData, {
      headers,
      params,
    });
  }
}
